import { useCallback, useState } from 'react';
import { noop } from 'lodash';
import { useAppDispatch } from '../../../store/hooks';
import { BulkEditOwnerRequest, BulkEditOwnerResponse } from '../types';
import { updateStockBulkOwner } from '../../../store/thunks/stock/stock-part-requests/stockBulkOperationsThunks';
import { ResponseSingleResult } from '../../../core/types/coreTypes';

type SuccessFn = (response: BulkEditOwnerResponse) => void;
type UpdateFn = (input: BulkEditOwnerRequest) => void;

export const useEditOwner = (onSuccess: SuccessFn = noop): [boolean, UpdateFn] => {
  const [pending, setIsPending] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const update: UpdateFn = useCallback(async (input) => {
    setIsPending(true);
    const data = await dispatch(updateStockBulkOwner(input));
    const response = data.payload as ResponseSingleResult<BulkEditOwnerResponse>;
    if (response.success) {
      onSuccess(response.data);
    }
    setIsPending(false);
  }, [dispatch, onSuccess]);

  return [pending, update];
};
